import api from './api';
class ProxmoxManagementService {
    getProxmoxMachines(selectedNode) {
        return api.get('/proxmox/machines/summary?selectedNode='+selectedNode);
    }

}
export default new ProxmoxManagementService();